<template>
  <div class="leasing">
    <div class="intro-y col-span-12 overflow-auto mt-5">
      <table class="table table-report -mt-2">
        <thead>
        <tr>
          <th class="whitespace-no-wrap">承租人或使用人</th>
          <th class="whitespace-no-wrap">管理单位名称</th>
          <th class="whitespace-no-wrap">资产编号</th>
          <th class="whitespace-no-wrap">资产出租地址明细</th>
          <th class="whitespace-no-wrap">合同开始时间</th>
          <th class="whitespace-no-wrap">合同结束时间</th>
          <th class="whitespace-no-wrap">年租金</th>
          <th class="whitespace-no-wrap">操作</th>
        </tr>
        </thead>
        <tbody>
        <tr
            v-for="(item, index) in data"
            :key="index"
            class="intro-x"
        >
          <td>
            <div class="font-medium whitespace-no-wrap">{{
                item.lesseeName
              }}</div>
          </td>
          <td>
            <div class="font-medium whitespace-no-wrap">{{
                item.manageEnterpriseName
              }}</div>
          </td>
          <td>
            <div class="font-medium whitespace-no-wrap">{{
                item.assetNumber
              }}</div>
          </td>
          <td>
            <div class="font-medium whitespace-no-wrap">{{
                item.certificateAddress
              }}</div>
          </td>
          <td>
            <div class="font-medium whitespace-no-wrap">{{
                item.contractStartDate
              }}</div>
          </td>
          <td>
            <div class="font-medium whitespace-no-wrap">{{
                item.contractEndDate
              }}</div>
          </td>
          <td>
            <div class="font-medium whitespace-no-wrap">{{
                item.annualContractRent
              }}</div>
          </td>
          <td class="table-report__action whitespace-no-wrap">

              <a class="flex items-center mr-3 text-theme-1" href="javascript:;" @click='checkHandle(item)'>
                查看
              </a>

          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <div
        class="intro-y col-span-12 flex flex-wrap sm:flex-row sm:flex-no-wrap items-center justify-space-between mt-5"
    >
      <el-pagination
          layout="prev, pager, next"
          :background='false'
          :page-size="form.perPage"
          :current-page="form.page"
          @current-change="handleTableChange"
          :total="total">
      </el-pagination>
      <select class="w-20 input box mt-3 sm:mt-0" @change='onShowSizeChange' v-model='form.perPage'>
        <option :value='10'>10</option>
        <option :value='25'>25</option>
        <option :value='35'>35</option>
        <option :value='50'>50</option>
      </select>
    </div>
    <!-- <a-table style="backgrund-color:#fff;" :columns="columns" :data-source="data" :loading="loading" :pagination="false">
      <span slot="action" slot-scope="value,action">
        <a @click="checkHandle(action)">查看</a>
      </span>
    </a-table>
    <div class="page">
      <a-pagination
        show-size-changer
        :hideOnSinglePage="!total"
        :current="form.page"
        :total="total"
        @change="handleTableChange"
        @showSizeChange="onShowSizeChange"
      />
    </div> -->
  </div>
</template>

<script>
  import {lesseeGetList} from '../../../api/tenant.js'
  export default {
    name: "leasing",
    components: {},
    data() {
      return {
        loading:false,
        form:{
          lesseeFullName:'',
          perPage:10,
          page:1
        },
        columns:[
          {
            title: '承租人或使用人',
            dataIndex: 'lesseeName',
          },
          {
            title: '管理单位名称',
            dataIndex: 'manageEnterpriseName',
          },
          {
            title: '资产编号',
            dataIndex: 'assetNumber',
          },
          
          {
            title: '资产出租地址明细',
            dataIndex: 'certificateAddress',
          },
          {
            title: '合同开始时间',
            dataIndex: 'contractStartDate',
          },
          {
            title: '合同结束时间',
            dataIndex: 'contractEndDate',
          },
          {
            title: '年租金',
            dataIndex: 'annualContractRent',
          },
          {
            title: '操作',
            dataIndex: 'action',
            scopedSlots: { customRender: 'action' },
          },
        ],
        data:[],
        total: 0,
      }
    },
    methods: {
      onShowSizeChange(current, pageSize){
        this.form.page=current;
        this.form.perPage=pageSize;
        this.lesseeGetList();
      },
      handleTableChange(page){
        this.form.page=page;
        this.lesseeGetList();
      },
      checkHandle(params){
        this.$router.push({path:'/assetManagement/assetDetail',query:{assetId:params.assetId,activeKey:'contract'}})
      },
      lesseeGetList(){
        let para=Object.assign({},this.form)
        this.loading = true
        lesseeGetList(para).then(res => {
          this.loading = false
          let data = res.data
          if (data.code === '000') {
            let arr = data.content.list
            for (let i in arr){
              arr[i].key = Number(i)
            }
            this.data = arr
            this.total = data.content.total
          } else {
            this.data = []
            this.total = 0
          }
        }).catch(err => {
          this.loading = false
          console.log(err);
        }).finally(() => {
          this.loading = false
        })
      },
    },
    created() {
      if(this.$route.query.broadside){
        this.form.lesseeFullName = this.$route.query.broadside
        
      }
      if(this.$route.query.assetCompanyId){
        this.form.companyId = this.$route.query.assetCompanyId
      }
      this.lesseeGetList()
    },
  }
</script>

<style scoped lang="scss">
  .leasing {
    .page{
      margin-top:15px;
      text-align: right;
    }
  }
</style>
